import { SettingKey } from 'data/ppoints/constants';
import { AppRecurringPricingDetails } from 'hooks/shopify/queries/get-all-app-subscriptions.graphql';
import useSettings from 'hooks/useSettings';
import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';
import { useAppSelector } from 'redux/hooks';
import { selectShopifyCurrentSubscription } from 'redux/slices/shopify-app-pricing/shopify-app-pricing.selector';
import { SubscribedSuccessfully } from '../../../pb/events/v1/subscribed_successfully_pb';
import { Feature } from '../../../pb/subscription/v1/addon_pb';

export const useHandleSubscribedSuccessfully = () => {
    const { settings: integrationMode, refetchWithoutLoading } = useSettings<IntegrationModeSetting>(
        SettingKey.integration_mode
    );
    const currentSubscription = useAppSelector(selectShopifyCurrentSubscription);

    const handleFeaturesRemoved = async (featuresRemoved: Feature[]) => {
        if (featuresRemoved.length === 0) return;

        const shouldRefetch = [
            [Feature.PICKUP_POINTS_ENABLED, IntegrationModeSetting.checkout],
            [Feature.CHECKOUT_MAP_DISPLAY, IntegrationModeSetting.checkout_map],
        ].some(([feature, mode]) => featuresRemoved.includes(feature as Feature) && integrationMode === mode);

        if (shouldRefetch) {
            await refetchWithoutLoading();
        }
    };

    const handleSubscribedSuccessfully = async (event: SubscribedSuccessfully) => {
        const currentPlanHandle = (
            currentSubscription?.lineItems?.[0]?.plan?.pricingDetails as AppRecurringPricingDetails
        )?.planHandle;
        if (event.activatedPlan !== currentPlanHandle) return;

        await handleFeaturesRemoved(event.featuresRemoved);
    };

    return { handleSubscribedSuccessfully };
};

export default useHandleSubscribedSuccessfully;
